import { render, staticRenderFns } from "./item_conf.vue?vue&type=template&id=454343a2&scoped=true"
import script from "./item_conf.vue?vue&type=script&lang=ts"
export * from "./item_conf.vue?vue&type=script&lang=ts"
import style0 from "./item_conf.vue?vue&type=style&index=0&id=454343a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454343a2",
  null
  
)

export default component.exports